import React from "react";
import TableWrapper from "../elements/TableWrapper";
import MiCompAPI from "../../util/api";
import moment from "moment";
import AddDocumentDrawer from "../User/AddDocumentDrawer";
import ApproveDocumentDrawer from "../User/ApproveDocumentDrawer";
import Book from "../Contracts/Book";
import { Layout, message, Spin, Row, Col, Menu, Modal, Button } from "antd";
import SearchBusinessForm from "../elements/SearchBusinessForm";
import ProvideNPNDrawer from "../elements/ProvideNPNDrawer";

const { Content } = Layout;
const { confirm } = Modal;

class Contracts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allContactsLoading: true,
      allSearchLoading: true,
      currentTab: "contracts",
      userDefaults: null,
      searchResults: [],
      checkNPNStatus: false,
      document_types: [],
      addDocumentActive: false,
      user: null,
      ApproveDocumentActive: false,
      doc_id: 0,
      entity_Type: null,
      serachcon: null,
      validation: null,
    };

    this.api = new MiCompAPI(this.props.userPermandMasters);
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
    this.DOCUMENT_COLUMNS = [
      {
        title: "Document Type",
        dataIndex: "document_type_name",
        sorter: (a, b) =>
          a.document_type_name.localeCompare(b.document_type_name),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Document Status",
        dataIndex: "status",
        render: (text, record) =>
          record["status"] === "Approved" ? (
            <p style={{ color: "#3fb53c", marginBottom: "-5px" }}>
              {record["status"]}
            </p>
          ) : record["status"] === "Rejected" ? (
            <p style={{ color: "#d62412", marginBottom: "-5px" }}>
              {record["status"]}
            </p>
          ) : (
            <p style={{ color: "#fdb47f", marginBottom: "-5px" }}>
              {record["status"]}
            </p>
          ),
        sorter: (a, b) => a.status.localeCompare(b.status),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Effective Date",
        dataIndex: "effective_date",
        render: (text, record) =>
          record["effective_date"] !== null && record["effective_date"] !== ""
            ? moment(record["effective_date"]).format("MM/DD/YYYY")
            : "",
        sorter: (a, b) =>
          new Date(a.effective_date) - new Date(b.effective_date),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Termination Date",
        dataIndex: "termination_date",
        render: (text, record) =>
          record["termination_date"] !== null &&
          record["termination_date"] !== ""
            ? moment(record["termination_date"]).format("MM/DD/YYYY")
            : "",
        sorter: (a, b) =>
          new Date(a.termination_date) - new Date(b.termination_date),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Renewal Date",
        dataIndex: "renewal_date",
        render: (text, record) =>
          record["renewal_date"] !== null && record["renewal_date"] !== ""
            ? moment(record["renewal_date"]).format("MM/DD/YYYY")
            : "",
        sorter: (a, b) => new Date(a.renewal_date) - new Date(b.renewal_date),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Submission Date",
        dataIndex: "submit_date",
        render: (text, record) =>
          record["submit_date"] !== null && record["submit_date"] !== ""
            ? moment(record["submit_date"]).format("MM/DD/YYYY")
            : "",
        sorter: (a, b) => new Date(a.submit_date) - new Date(b.submit_date),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Approval Date",
        dataIndex: "date_approved",
        render: (text, record) =>
          record["date_approved"] !== null && record["date_approved"] !== ""
            ? moment(record["date_approved"]).format("MM/DD/YYYY")
            : "",
        sorter: (a, b) => new Date(a.date_approved) - new Date(b.date_approved),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Action",
        dataIndex: "url",
        width: 50,
        render: (text, record) => {
          return (
            <div style={{ display: "flex" }}>
              {record["submit_date"] !== null ? (
                <i
                  style={{ marginRight: "0px !important", marginTop: "10px" }}
                  onClick={() => window.open(record.document_name, "_blank")}
                  className="fa fa-eye fa-b"
                />
              ) : (
                <i
                  style={{ marginRight: "0px !important", marginTop: "10px" }}
                  onClick={() =>
                    window.open(record.document_type_path, "_blank")
                  }
                  className="fa fa-download fa-b"
                />
              )}
              {this.state.userDefaults &&
              ((this.state.userDefaults.loggedUserEntityType === "AGENCY" &&
                record.entity_Type === "Broker") ||
                this.state.userDefaults.loggedUserEntityType === "CARRIER") ? (
                <>
                  {record["status"] !== "Approved" &&
                  record["status"] !== "Rejected" &&
                  record["status"] !== "Pending" ? (
                    <>
                      <i
                        style={{ marginTop: "10px" }}
                        title="Approve Document"
                        className="fa fa-check-square-o fa-green"
                        onClick={() => {
                          this.ApproveDocumentDefaultHandler(record, true);
                        }}
                      />
                      <i
                        style={{ marginTop: "10px" }}
                        title="Reject Document"
                        className="fa fa-ban fa-red"
                        onClick={() => {
                          this.changeDocumentStatus(record, false);
                        }}
                      />
                    </>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}
              {this.state.userDefaults &&
              (this.state.userDefaults.loggedUserEntityType === "BROKER" ||
                record.entity_Type === "Carrier") ? (
                <>
                  {record["status"] !== "Approved" &&
                  record["status"] !== "Rejected" &&
                  record["status"] !== "Pending" ? (
                    <i
                      style={{ marginTop: "10px" }}
                      title="Delete Document"
                      className="fa fa-trash fa-red"
                      onClick={() => {
                        this.deleteDoc(record["id"], false);
                      }}
                    />
                  ) : (
                    ""
                  )}
                  {record["status"] === "Pending" ? (
                    <i
                      className="fa fa-upload fa-b"
                      style={{ marginTop: "9px" }}
                      onClick={() => this.addDocumentDefaultHandler(record)}
                    ></i>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
    ];
    this.columns = [
      {
        title: "State",
        dataIndex: "state",
        sorter: (a, b) => a.state.localeCompare(b.state),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Entity Type",
        dataIndex: "entity_Type",
        sorter: (a, b) => a.entity_Name.localeCompare(b.entity_Name),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Entity Name",
        dataIndex: "entity_Name",
        sorter: (a, b) => a.entity_Name.localeCompare(b.entity_Name),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Contract Start Date",
        dataIndex: "start_Date",
        render: (text, record) =>
          record["start_Date"] !== null && record["start_Date"] !== ""
            ? moment(record["start_Date"]).format("MM/DD/YYYY")
            : "",
        sorter: (a, b) => a.start_Date.localeCompare(b.start_Date),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Contract End Date",
        dataIndex: "end_Date",
        render: (text, record) =>
          record["end_Date"] !== null && record["end_Date"] !== ""
            ? moment(record["end_Date"]).format("MM/DD/YYYY")
            : "",
        sorter: (a, b) => a.end_Date.localeCompare(b.end_Date),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "LOA",
        dataIndex: "loa",
        sorter: (a, b) => a.loa.localeCompare(b.loa),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Status",
        dataIndex: "status",
        sorter: (a, b) => a.status.localeCompare(b.status),
        sortDirections: ["descend", "ascend"],
      },
    ];
    this.searchResultsColumns = [
      {
        title: "Entity Type",
        dataIndex: "entity_type",
        sorter: (a, b) => a.entity_Name.localeCompare(b.entity_Name),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Entity Name",
        dataIndex: "entity",
        sorter: (a, b) => a.entity.localeCompare(b.entity),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "LOA",
        dataIndex: "loa",
        sorter: (a, b) => a.loa.localeCompare(b.loa),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "State",
        dataIndex: "state",
        sorter: (a, b) => a.state.localeCompare(b.state),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Connect",
        dataIndex: "contract_action",
        width: 50,
        render: (text, record) => {
          return (
            <div>
              <Button
                // disabled={
                //   !(
                //     role === "carrier" ||
                //     (this.state.validation &&
                //       this.state.validation[record.entity_type.toLowerCase()])
                //   )
                // }
                className="connect-button"
                onClick={() => this.showConfirm(record)}
                style={{
                  width: "fit-content",
                  marginLeft: "12px",
                  right: "6.67%",
                  border: "1px solid #4E5694",
                }}
              >
                <b>Connect</b>
              </Button>
            </div>
          );
        },
      },
    ];
  }
  handleClick = (e) => {
    this.setState({
      currentTab: e.key,
    });
  };
  componentDidMount() {
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
    if(role!=='carrier'){
     // this.subscriptionValidation();
    }   
    this.getContracts();
    this.getClientMasters();
  }
  subscriptionValidation = () => {
    this.api.invoke("SubscriptionValidation", "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          this.setState({ validation: data.data });
          this.setState({ allInvitationsLoading: false });
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  };

  deleteDoc(doc_id, type) {
    this.api.invoke(
      "PersonalDocDelete/" + doc_id,
      "delete",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            message.success(data.statusMessage, 3);
            this.getContracts();
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      }
    );
  }
  ApproveDocumentDefaultHandler = (data, states) => {
    if (states) {
      this.setState({ doc_id: data.id, entity_Type: data.entity_Type });
    }
    this.setState({ ApproveDocumentActive: !this.state.ApproveDocumentActive });
  };
  changeDocumentStatus = (docdata, status) => {
    this.api.invoke(
      "ApproveOrRejectUserDoc",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            if (status) {
              this.setState({
                ApproveDocumentActive: !this.state.ApproveDocumentActive,
              });
            }
            //this.subscriptionValidation();
            message.destroy();
            message.success(data.statusMessage, 3);
            this.setState({ addDocumentActive: false });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
          this.getContracts();
        } else {
          message.destroy();
          message.error("Add document failed. Contact Support", 3);
        }
      },
      {
        role: this.state.entity_Type,
        id: docdata.id,
        isApprove: status,
        termination_date: status ? docdata.termination_date : null,
        renewal_date: status ? docdata.renewal_date : null,
      }
    );
  };
  SaveandUpdateContracts = (data) => {
    data = {
      to_Id: data.user_id,
      start_Date: data.start_Date,
      end_Date: data.end_Date,
      loa: this.state.serachcon.strLOADesc,
      state: this.state.serachcon.iStateId,
    };
    this.api.invoke(
      "SaveandUpdateContracts",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            message.success(data.statusMessage, 3);
            //this.subscriptionValidation();
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
          this.getContracts();
        }
      },
      data
    );
  };
  showConfirm = (record) => {
    confirm({
      title: "Do you want to connect to " + record["entity"] + "?",
      onOk: () => this.SaveandUpdateContracts(record),
      okText: "Yes",
      onCancel() {},
      cancelText: "No",
    });
  };
  getContracts = () => {
    this.api.invoke("GetContracts", "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          const Contracts = data.data;
          this.data = Contracts;
          this.setState({ allContractsLoading: false });
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      } else {
      }
    });
  };
  getClientMasters() {
    this.api.invoke(
      "GetMasters",
      "post",
      (data, success) => {
        if (success) {
          this.setState({
            document_types: data.document_types,
            address_types: data.address_types,
            states: data.states,
          });
        }
      },
      ["ADDRESS_TYPE", "AGENCYDOCUMENT_TYPE", "STATE", "DOCUMENT_TYPE"]
    );
  }

  handleCallback = (childData) => {
    this.setState({
      userDefaults: childData.userDefaults,
      allSearchLoading: false,
    });
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
    // if (childData.userDefaults&&(childData.userDefaults.userNpn == null || childData.userDefaults.userNpn === "" || childData.userDefaults.userLoa.length === 0) && childData.userDefaults.loggedUserEntityType !== "CARRIER") {

    //   this.checkNPNDefaultHandler();
    // }else if(!childData.userDefaults.isAcceptedTermsandConditions){
    //   this.checkNPNDefaultHandler();

    // }else if(!childData.userDefaults.isDontShowAgainTermsandConditions){
    //   this.checkNPNDefaultHandler();
    // }
    // else {
    var data = {
      strLOADesc: childData.lob[0].name,
      strEntityTypeDesc: childData.entity[0].name,
      iStateId: childData.usstates[0].name,
    };
    this.setState({
      serachcon: data,
    });
    this.setState({ allSearchLoading: true, searchResult: [] });
    if (
      role === "carrier" ||
      (this.state.validation &&
        this.state.validation[childData.entity[0].name.toLowerCase()])
    ) {
      this.api.invoke(
        "GetContractsBusinessSearchWithOptions",
        "post",
        (data, success) => {
          if (success) {
            if (data.statusCode === 200) {
              this.setState({
                searchResults: data.data,
                allSearchLoading: false,
              });
            } else {
              message.destroy();
              message.error(data.statusMessage, 3);
            }
            this.getContracts();
          }
        },
        data
      );
    } else {
      this.setState({ allSearchLoading: false, searchResult: [] });
    }
    //}
  };
  addDocumentDefaultHandler = (data) => {
    this.setState({
      addDocumentActive: !this.state.addDocumentActive,
      user: data,
    });
  };

  addDocumentSubmitHandler = (data, callback) => {
    data = {
      iDocType_Id: this.state.user.document_type_id,
      strDoc_Name: data.name,
      st_base64_file: data.file,
      c_Id: this.state.user.to_Id,
      loa_Id: this.state.user.loa_Id,
      state_Id: this.state.user.state_Id,
    };
    message.loading("Adding Document..", 0);
    this.api.invoke(
      "PersonalDocInsert",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            message.success(data.statusMessage, 3);
            this.setState({ addDocumentActive: false });
            //this.subscriptionValidation();
            callback(true);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
            callback(false);
          }
        } else {
          message.destroy();
          message.error("Add document failed. Contact Support", 3);
          callback(false);
        }
        this.getContracts();
      },
      data
    );
  };

  getSelectedTabView() {
    if (this.state.isLoading) {
      return (
        <div className="mi_main" style={{ textAlign: "center" }}>
          <Spin size="large" />
        </div>
      );
    }
    switch (this.state.currentTab) {
      case "contracts": {
        return (
          <Row span={24}>
            <Col md={24} sm={24}>
              <div>
                {!this.state.checkNPNStatus ? (
                  <Row span={24}>
                    <SearchBusinessForm
                      userPermandMasters={this.props.userPermandMasters}
                      parentCallBack={this.handleCallback}
                      dataFromParent={this.state}
                      submitHandler={this.SubmitHandler}
                    ></SearchBusinessForm>
                  </Row>
                ) : (
                  ""
                )}
                <Row span={24} style={{ padding: "0px 15px" }}>
                  <TableWrapper
                    columns={this.searchResultsColumns}
                    locale={{
                      emptyText: "Search results did not match any data",
                    }}
                    loading={this.state.allSearchLoading}
                    rowKey="user_id"
                    data={this.state.searchResults}
                    title="Search Results"
                    search={false}
                  />
                  <TableWrapper
                    expandedRowRender={(record) => (
                      <>
                        <TableWrapper
                          rowKey="document_id"
                          data={record.docs.map((x) => {
                            return {
                              ...x,
                              entity_Type: record.entity_Type,
                              to_Id: record.to_Id,
                              loa_Id: record.loa_Id,
                              state_Id: record.state_Id,
                            };
                          })}
                          columns={this.DOCUMENT_COLUMNS}
                        ></TableWrapper>
                      </>
                    )}
                    columns={this.columns}
                    rowKey="id"
                    data={this.state.allContractsLoading ? null : this.data}
                    loading={this.state.allContractsLoading}
                    title="All Contracts"
                    buttons={this.tableButtons}
                    search={true}
                  />
                </Row>
              </div>
            </Col>
          </Row>
        );
      }
      case "mybook":
        return (
          <Book
            {...this.props}
            userPermandMasters={this.props.userPermandMasters}
          />
        );
      default:
        break;
    }
  }

  checkNPNDefaultHandler = () => {
    this.setState({ checkNPNStatus: !this.state.checkNPNStatus });
  };

  checkNPNSubmitHandler = (data, callback) => {
    var postData = {
      userId: this.state.userDefaults.userId,
      userNpn: data.npn,
      userState: this.state.userDefaults.userState,
      entityType: this.state.userDefaults.entityType,
      loggedUserEntityType: this.state.userDefaults.loggedUserEntityType,
      isDontShowAgainTermsandConditions: data.isDontShowAgainTermsandConditions,
      isTnC: data.tnc,
    };

    message.loading("Updating NPN...", 0);
    this.api.invoke(
      "UpdateUserNPN",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            message.success(data.statusMessage, 3);
            this.setState({ checkNPNStatus: false });
            callback(true);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
            callback(false);
          }
          this.getContracts();
          this.getClientMasters();
        } else {
          message.destroy();
          message.error("NPN Status Update failed.", 3);
          this.setState({ checkNPNStatus: false });
          callback(true);
        }
      },
      postData
    );
  };
  SubmitHandler = (data) => {
    // if (this.state.userDefaults&&(this.state.userDefaults.userNpn == null || this.state.userDefaults.userNpn === "") && this.state.userDefaults.loggedUserEntityType !== "CARRIER") {
    //   this.checkNPNDefaultHandler();
    // }
    // else {
    this.setState({
      serachcon: data,
    });
    this.setState({ allSearchLoading: true, searchResult: [] });
    this.api.invoke(
      "GetContractsBusinessSearchWithOptions",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              searchResults: data.data,
              allSearchLoading: false,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      data
    );
    //}
  };
  render() {
    const { decodedToken, Permissions } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;

    return (
      <Content>
        {this.state.checkNPNStatus ? (
          <Modal visible={this.state.checkNPNStatus}>
            <ProvideNPNDrawer
              userNpn={this.state.userDefaults.userNpn}
              closeDrawerHandler={() => this.props.history.push("/")}
              submitHandler={this.checkNPNSubmitHandler}
              width={500}
              title="NPN Usage Acceptance"
            />
          </Modal>
        ) : null}
        {this.state.addDocumentActive ? (
          <Modal visible={this.state.addDocumentActive}>
            <AddDocumentDrawer
              closeDrawerHandler={this.addDocumentDefaultHandler}
              submitHandler={this.addDocumentSubmitHandler}
              width={500}
              userPermandMasters={this.props.userPermandMasters}
              title="Enter New Document"
            />
          </Modal>
        ) : null}
        {this.state.ApproveDocumentActive ? (
          <Modal visible={this.state.ApproveDocumentActive}>
            <ApproveDocumentDrawer
              closeDrawerHandler={this.ApproveDocumentDefaultHandler}
              submitHandler={this.changeDocumentStatus}
              width={500}
              userPermandMasters={this.props.userPermandMasters}
              title="Approve Document"
              id={this.state.doc_id}
            />
          </Modal>
        ) : null}
        <div className="mi_main_div">
          {role === "carrier" ||
          Permissions[0].subscription_Type === "Standard" ||
          Permissions[0].subscription_Type === "Premium" ? (
            <Menu
              className="mi_general_bar"
              style={{ width: "fit-content" }}
              onClick={this.handleClick}
              selectedKeys={[this.state.currentTab]}
              mode="horizontal"
            >
              <Menu.Item
                className="mi_menu_item mi_menu_item:last-child"
                key="contracts"
              >
                Contracts
              </Menu.Item>
              <Menu.Item
                className="mi_menu_item mi_menu_item:last-child "
                key="mybook"
              >
                {role === "broker" ? "My Book" : "Our Book"}
              </Menu.Item>
            </Menu>
          ) : (
            <p
              style={{ marginBottom: "-10px", marginLeft: "10px" }}
              className="mi_table_title"
            >
              Contracts
            </p>
          )}
          {this.getSelectedTabView()}
        </div>
      </Content>
    );
  }
}
export default Contracts;
